<template>
  <div class="InfoCenter">
    <!-- <div class="goback"
         @click="goBack">返回</div> -->
    <div class="title">
      消息中心
      <div class="isInfo">
        <span class="unread">未读</span>
        <span class="readed">已读</span>
      </div>
    </div>
    <div class="data_show">
      <div class="data_detail"
           v-for="(item,index) of backData"
           :key="index"
           @click="toDetail(item.id)">
        <div class="title"
             :title="item.title">{{item.title}}</div>
        <div class="detail_txt"
             :title="item.content">
          <span class="is_select"
                v-if="item.noticeRead"></span>
          <span class="is_select not_select"
                v-else></span>

          <span class="content">{{item.content}}</span>
          <span class="date">{{item.createdTime}}</span>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination background
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[5,10,20]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"></el-pagination>
    </div>
  </div>
</template>
<script>
import { getNoticeInfo, getNoticeDetail } from "common/js/api";

export default {
  data () {
    return {
      backData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      userCode: ""
    };
  },

  created () {
    this.userCode = this.Cookies.get("identifyCode");
    this.getList();
  },

  methods: {
    async getList () {
      const data = {
        page: this.currentPage,
        size: this.pageSize,
        userInstitutionCode: this.userCode
      };

      const { result } = await getNoticeInfo(data);
      this.backData = result.list;
      this.currentPage = result.pageNum;
      this.pageSize = result.pageSize;
      this.total = result.total;
    },

    handleSizeChange (val) {

      this.pageSize = val;
      this.currentPage = 1;
      this.getList();
    },

    handleCurrentChange (val) {

      this.currentPage = val;
      this.getList();
    },

    goBack () {
      this.$router.push("/UC/User");
    },

    toDetail (id) {

      this.$router.push({
        path: "/UC/InfoDetail",
        query: {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          userCode: this.userCode,
          id
        }
      });
      this.getDetailed(id);
    },

    //通知详情
    async getDetailed (id) {
      await getNoticeDetail(id);
    }
  }
};
</script>
<style scoped lang="scss">
.InfoCenter {
  position: relative;
  height: 100%;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.5);
  padding: 30px 20px;
  display: flex; overflow:auto;
  flex-direction: column;
}
// .goback {
//   position: absolute;
//   cursor: pointer;
//   width: 100px;
//   height: 28px;
//   line-height: 28px;
//   text-align: center;
//   right: 20px;
//   top: 0;
//   border: 1px solid #dddddd;
//   border-radius: 2px;
//   font-size: 12px;
//   color: #6c7885;
// }
.data_show {
  flex: 1;
  overflow:auto;
  padding-top: 40px;
}
.data_detail {
  cursor: pointer;
  margin: 0 0 30px 0;
  border-bottom: 1px solid #f0f2f5;
  padding-bottom: 20px;
}
.pagination {
  text-align: right;
}
.is_select {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  vertical-align: -2px;
  margin-right: 5px;
  background: #dddddd;
}
.not_select {
  background: red;
}
/* .is_selected {
  background: #fb5353;
} */
.data_detail .title {
  font-size: 18px;
  font-family: Alibaba;
  text-align: left;
  color: #191818;
  margin-bottom: 8px;
}
.data_detail .detail_txt {
  display: flex; overflow:auto;
  align-items: center;
  font-size: 16px;
  color: #b6bcc2;
}
.title {
  font-size: 24px;
  font-family: Alibaba;
  text-align: left;
  color: #191818;
  display: flex; 
  flex-direction: row;
  align-items: flex-end;
  .isInfo {
    flex: 1;
    font-size: 16px;
    font-family: AlibabaM;
    color: #191818;
    text-align: right;
    .unread {
      &:before {
        display: inline-block;
        content: "";
        width: 12px;
        height: 12px;
        margin-right: 5px;
        background: #ff2626;
        border-radius: 50%;
      }
      margin: 20px;
    }
    .readed {
      &:before {
        content: "";
        display: inline-block;

        width: 12px;
        height: 12px;
        margin-right: 5px;
        background: #999;
        border-radius: 50%;
      }
    }
  }
}
.content {
  // display: inline-block;
  // width: 90%;
  font-size: 14px;
  font-family: Alibaba;
  text-align: left;
  line-height: 20px;
  color: #999999;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
.date {
  text-align: right;
  flex: 1;
  overflow: auto;
}
</style>

